export default __webpack_public_path__ + "static/media/TS1.4f747d01.png";